import { render, staticRenderFns } from "./LightLogDivCom.vue?vue&type=template&id=cc9b7f70&"
import script from "./LightLogDivCom.vue?vue&type=script&lang=ts&"
export * from "./LightLogDivCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports